import React from 'react';
import '../styles/NotFound.css';


function NotFound() {
  return (
    <div>
        <h1>404 - Page Not Found</h1>
    </div>
  );
}

export default NotFound;